// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__xt9Jt","left":"StickyBox_left__1R7zz","right":"StickyBox_right__1cKzM"};